<template>
	<div class="market-wrap">
		<div class="loan-market-ad">
			<img src="./img/loan_market_logo.png"/>
			<div class="desc">
				<span>Explore more loan products.</span>
				<div class="withdraw-con" @click="withdraw">
					Withdraw
					<div class="un-read" v-if='productNum'>{{productNum}}</div>
				</div>
			</div>
			<div class="tag">Advertisement</div>
		</div>
		<p class="market-tips">More products will continue to be unlocked...</p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				productNum:null,//贷超产品数量
			}
		},
		created(){
			this.getDcProductList();
		},
		
		methods: {
			withdraw(){
				if(!this.productNum){
					this.UTILS.logStr("Repay on time 3 times and unlock more products – more to come!");
					return
				}
				this.$emit("toMarket")
			},
			
			getDcProductList() {
				this.UTILS.axiosRequest('post', this.PATHS.loanPath + '/dc/getDcProductList ', {}, (res) => {
					this.UTILS.loadGif.hide();
					if (res.code == '0000') {
						this.productNum = res?.data?.length || 0
					} else {
						this.productNum = 0
						this.UTILS.logStr(res.message);
					}
				}, 1);
			},
		}
	}
</script>

<style scoped>
.market-wrap{margin: 0.4rem 0;}
.loan-market-ad{width: 100%;height: 2.4rem;padding-left:1.0rem;position: relative;display: flex;align-items: center;gap: 0 0.2rem;background: url("./img/loan_market_bg.png") no-repeat center;background-size: 100%;}
.loan-market-ad img{width: 2.3rem;}
.loan-market-ad .desc{display: flex;flex-direction: column;gap: 0.1rem;align-items: flex-end;margin-top: 0.2rem;}
.loan-market-ad .desc span{font-size:0.24rem;color: #000000;}
.loan-market-ad .desc .withdraw-con{position: relative;width: 2.0rem;height: 0.6rem;line-height: 0.6rem;background: #5A6DFF;border-radius:0.4rem;font-weight: bold;color: #fff;text-align: center;font-size: 0.28rem;}
.loan-market-ad .desc .un-read{position: absolute;top: -5px;right: 0;width: 0.32rem;height: 0.32rem;font-size: 0.2rem;display: flex;align-items: center;justify-content: center;font-size: 0.20rem;border-radius: 50%;background: #FF0000;font-weight: normal;}
.loan-market-ad .tag{position: absolute;left: 0.3rem;top: 0;color: #FFFFFF;padding: 0.04rem;background: #E300E7;font-size: 0.2rem;}
.market-tips{font-size: 0.2rem;color: #3D3D3D;text-align: center;}
</style>
